import m from "mithril";
import toast from "../js/toaster";

const ResetPassword = {
    token: "",
    password: "",
    confirmPassword: "",
    isLoading: false,
    isValidating: true,
    isValid: false,
    error: "",
    success: false,

    async oninit(vnode) {
        this.token = vnode.attrs.token;
        if (!this.token) {
            this.error = "Token tidak ditemukan";
            this.isValidating = false;
            return;
        }

        // Validate token
        try {
            const res = await fetch(`/api/secure-auth/reset-password/${this.token}`, {
                method: 'GET'
            });
            const data = await res.json();

            if (res.ok && data.success) {
                this.isValid = true;
            } else {
                this.error = data.error || "Token tidak valid atau sudah kadaluarsa";
            }
        } catch (error) {
            console.error('Token validation error:', error);
            this.error = "Terjadi kesalahan saat memvalidasi token";
        } finally {
            this.isValidating = false;
            m.redraw();
        }
    },

    async onsubmit(e) {
        e.preventDefault();

        if (this.password !== this.confirmPassword) {
            this.error = "Konfirmasi password tidak cocok";
            return;
        }

        if (this.password.length < 6) {
            this.error = "Password minimal 6 karakter";
            return;
        }

        this.isLoading = true;
        this.error = "";
        m.redraw();

        try {
            const res = await fetch(`/api/secure-auth/reset-password/${this.token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ password: this.password })
            });

            const data = await res.json();

            if (res.ok && data.success) {
                this.success = true;
                toast.success(data.message);
                setTimeout(() => {
                    m.route.set('/login');
                }, 3000);
            } else {
                this.error = data.error || "Gagal mengatur ulang password";
                toast.error(this.error);
            }
        } catch (error) {
            console.error('Reset password error:', error);
            this.error = "Terjadi kesalahan koneksi";
            toast.error(this.error);
        } finally {
            this.isLoading = false;
            m.redraw();
        }
    },

    view() {
        if (this.isValidating) {
            return m("div", { class: "min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900" }, [
                m("div", { class: "text-center" }, [
                    m("i", { class: "ri-loader-4-line animate-spin text-4xl text-orange-600" }),
                    m("p", { class: "mt-2 text-gray-600 dark:text-gray-400" }, "Memvalidasi token...")
                ])
            ]);
        }

        return m("div", { class: "min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4" }, [
            m("div", { class: "max-w-md w-full bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 space-y-6" }, [
                m("div", { class: "text-center" }, [
                    m("div", { class: "mx-auto bg-orange-100 dark:bg-orange-900/30 w-16 h-16 rounded-full flex items-center justify-center mb-4" }, [
                        m("i", { class: "ri-key-2-line text-3xl text-orange-600 dark:text-orange-400" })
                    ]),
                    m("h2", { class: "text-2xl font-bold text-gray-900 dark:text-white" }, "Atur Ulang Password"),
                    m("p", { class: "text-gray-600 dark:text-gray-400 mt-2" }, "Silakan masukkan password baru Anda.")
                ]),

                this.error ? m("div", { class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3 text-red-700 dark:text-red-300 text-sm flex items-center" }, [
                    m("i", { class: "ri-error-warning-line mr-2" }),
                    this.error
                ]) : null,

                this.success ? m("div", { class: "bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-3 text-green-700 dark:text-green-300 text-sm" }, [
                    m("p", { class: "flex items-center" }, [
                        m("i", { class: "ri-checkbox-circle-line mr-2" }),
                        "Password berhasil diatur ulang."
                    ]),
                    m("p", { class: "mt-2 font-medium" }, "Mengalihkan ke halaman login...")
                ]) : null,

                this.isValid && !this.success ? m("form", { onsubmit: (e) => this.onsubmit(e) }, [
                    m("div", { class: "space-y-4" }, [
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Password Baru"),
                            m("input", {
                                type: "password",
                                placeholder: "Minimal 6 karakter",
                                class: "block w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-orange-500 focus:outline-none transition-colors duration-200",
                                value: this.password,
                                oninput: (e) => { this.password = e.target.value; },
                                disabled: this.isLoading,
                                required: true
                            })
                        ]),
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Konfirmasi Password Baru"),
                            m("input", {
                                type: "password",
                                placeholder: "Ulangi password baru",
                                class: "block w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-orange-500 focus:outline-none transition-colors duration-200",
                                value: this.confirmPassword,
                                oninput: (e) => { this.confirmPassword = e.target.value; },
                                disabled: this.isLoading,
                                required: true
                            })
                        ])
                    ]),

                    m("button", {
                        type: "submit",
                        class: "w-full mt-6 flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50 transition-all duration-200",
                        disabled: this.isLoading
                    }, [
                        this.isLoading ? m("i", { class: "ri-loader-4-line animate-spin mr-2" }) : null,
                        "Perbarui Password"
                    ])
                ]) : (!this.success ? m("div", { class: "text-center mt-4" }, [
                    m("a", {
                        href: "/forgot-password",
                        oncreate: m.route.link,
                        class: "text-sm font-medium text-orange-600 hover:text-orange-500 dark:text-orange-400 dark:hover:text-orange-300 transition-colors duration-200"
                    }, "Minta tautan baru")
                ]) : null)
            ])
        ]);
    }
};

export default ResetPassword;
